var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.8086,
    y1: 184.873,
    x2: 75.8086,
    y2: 48.113,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#FFBF5C"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.063,
    y: 311.376,
    style: {
      fill: "url(#SVGID_1_)"
    },
    width: 120.471,
    height: 154.604
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.6335,
    y1: 220.293,
    x2: 74.6335,
    y2: 170.563,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M141.553,344.502H16.333c-5.131,0-8.804-4.954-7.315-9.865l12.426-40.932 c0.978-3.222,3.948-5.423,7.315-5.423h112.795V344.502z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 433.8086,
    y1: 184.873,
    x2: 433.8086,
    y2: 48.113,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#FFBF5C"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 375.467,
    y: 311.376,
    style: {
      fill: "url(#SVGID_3_)"
    },
    width: 120.471,
    height: 154.604
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 431.0087,
    y1: 77.4431,
    x2: 306.6187,
    y2: 188.2931,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    points: "495.937,425.473 414.996,344.531 375.467,344.531 375.467,465.976 495.937,465.976  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.9837,
    y1: 220.293,
    x2: 434.9837,
    y2: 170.563,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M370.447,344.502h125.22c5.131,0,8.804-4.954,7.315-9.865l-12.426-40.932 c-0.978-3.222-3.948-5.423-7.315-5.423H370.447V344.502z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8306,
    y1: 249.243,
    x2: 254.8306,
    y2: -36.257,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#FFBF5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DB9E36"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    points: "415.066,221.101 415.066,465.976 96.978,465.976 96.978,221.101 256.022,61.094 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.5581,
    y1: 288.5025,
    x2: 108.9181,
    y2: 427.1425,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    points: "415.061,221.1 415.061,465.976 314.639,465.976 96.979,248.316 96.979,221.1  256.02,61.095 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.2486,
    y1: 233.613,
    x2: 192.5786,
    y2: 403.283,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M157.143,160.571c3.436,23.436,15.001,44.23,31.747,59.419l226.176,226.177V221.101 L256.022,61.094L157.143,160.571z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.9774,
    y1: 119.5518,
    x2: 75.0374,
    y2: 262.5018,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    d: "M365.913,465.976H210.349l-85.514-85.514c-3.765-2.441-6.27-6.676-6.27-11.48v-68.825 c0-7.54,6.139-13.679,13.679-13.679h49.619c4.815,0,9.05,2.506,11.491,6.27l-0.372,0.295L365.913,465.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#503837"
    },
    d: "M181.863,374.642h-49.615c-3.129,0-5.665-2.536-5.665-5.665v-68.815c0-3.129,2.537-5.665,5.665-5.665 h49.615c3.129,0,5.665,2.536,5.665,5.665v68.815C187.529,372.107,184.992,374.642,181.863,374.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M181.863,382.662h-49.615c-7.545,0-13.684-6.139-13.684-13.684v-68.815 c0-7.545,6.139-13.684,13.684-13.684h49.615c7.545,0,13.684,6.139,13.684,13.684v68.815 C195.548,376.523,189.409,382.662,181.863,382.662z M134.603,366.623h44.906v-64.107h-44.906V366.623z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 393.5514,
    y1: 143.0358,
    x2: 302.0314,
    y2: 234.5558,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    d: "M415.072,314.866v151.11h-4.881l-85.514-85.514c-3.776-2.441-6.282-6.676-6.282-11.48 v-68.825c0-7.54,6.139-13.679,13.69-13.679h49.608c4.815,0,9.05,2.506,11.491,6.27l0.197,0.154l-0.132,0.143L415.072,314.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#503837"
    },
    d: "M381.697,374.642h-49.615c-3.129,0-5.665-2.536-5.665-5.665v-68.815c0-3.129,2.536-5.665,5.665-5.665 h49.615c3.129,0,5.665,2.536,5.665,5.665v68.815C387.363,372.107,384.826,374.642,381.697,374.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M381.698,382.662h-49.615c-7.545,0-13.684-6.139-13.684-13.684v-68.815 c0-7.545,6.139-13.684,13.684-13.684h49.615c7.545,0,13.684,6.139,13.684,13.684v68.815 C395.382,376.523,389.243,382.662,381.698,382.662z M334.436,366.623h44.906v-64.107h-44.906V366.623z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8091,
    y1: 336.023,
    x2: 254.8091,
    y2: 175.583,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    d: "M451.033,243.222l-185.439-185.5c-5.286-5.286-13.855-5.286-19.141,0L60.968,243.207 c-3.458,3.458-3.458,9.064,0,12.522l7.905,7.905c3.458,3.457,9.064,3.457,12.522,0L253.503,91.527c1.391-1.391,3.647-1.391,5.04,0 l172.063,172.122c3.458,3.458,9.064,3.458,12.522,0l7.905-7.905C454.49,252.286,454.49,246.68,451.033,243.222z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.4585,
    y1: 295.9729,
    x2: 321.4985,
    y2: 377.4229,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D54003",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A40002"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "M265.593,57.722c-2.643-2.643-6.107-3.964-9.57-3.964v36.725c0.912,0,1.824,0.348,2.52,1.044 L430.606,263.65c3.458,3.457,9.064,3.457,12.522,0l7.905-7.905c3.458-3.458,3.458-9.064,0-12.522L265.593,57.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#816965"
    },
    d: "M222.877,465.972V292.203c0-7.665,6.213-13.878,13.878-13.878h38.536 c7.665,0,13.878,6.213,13.878,13.878v173.769H222.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#503837"
    },
    d: "M297.376,465.972H280.96V296.935c0-5.72-4.68-10.401-10.401-10.401h-29.074 c-5.744,0-10.401,4.656-10.401,10.401v169.037h-16.415V286.079c0-8.815,7.146-15.961,15.961-15.961h50.784 c8.815,0,15.961,7.146,15.961,15.961v179.893H297.376z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 244.264,
    cy: 343.552,
    r: 7.484
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.969,
    y: 422.179,
    style: {
      fill: "#654E48"
    },
    width: 318.103,
    height: 43.792
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.1117,
    y1: 96.4221,
    x2: 77.5677,
    y2: 38.9721,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9EB644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#738611"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    d: "M93.486,448.86c0,6.044-1.143,11.811-3.231,17.112H3.231C1.143,460.672,0,454.904,0,448.86 c0-5.885,1.085-11.511,3.072-16.694c6.719-17.579,23.739-30.049,43.672-30.049s36.952,12.471,43.672,30.049 C92.402,437.35,93.486,442.976,93.486,448.86z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.1305,
    y1: 83.7849,
    x2: 111.8105,
    y2: 42.1049,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9EB644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#738611"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_14_)"
    },
    d: "M123.628,453.56c0,4.384-0.829,8.567-2.343,12.413H58.156 c-1.514-3.845-2.343-8.029-2.343-12.413c0-4.269,0.787-8.35,2.229-12.11c4.874-12.752,17.22-21.798,31.68-21.798 s26.806,9.046,31.68,21.798C122.841,445.209,123.628,449.291,123.628,453.56z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 424.9258,
    y1: 104.0502,
    x2: 491.8958,
    y2: 37.0802,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9EB644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#738611"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_15_)"
    },
    d: "M512,446.025c0,7.045-1.333,13.768-3.766,19.947H406.79 c-2.432-6.178-3.766-12.902-3.766-19.947c0-6.86,1.265-13.417,3.581-19.46c7.833-20.491,27.672-35.028,50.907-35.028 c23.235,0,43.074,14.537,50.907,35.028C510.735,432.608,512,439.166,512,446.025z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.6501,
    y1: 414.3245,
    x2: 361.8701,
    y2: 262.0945,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7BAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E24786"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_16_)"
    },
    cx: 256,
    cy: 145.95,
    r: 99.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.8006,
    y1: 247.295,
    x2: 282.4306,
    y2: 348.665,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7BAC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E24786"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_17_)"
    },
    d: "M355.927,145.951c0-0.174-0.005-0.346-0.006-0.52l-37.061-37.061 c-6.078-6.665-14.486-11.082-24.324-11.562c-16.528-0.805-30.793,9.332-36.207,23.793l-11.853-11.79 c-7.094-7.815-17.503-12.564-29.011-12.003c-22.878,1.114-38.063,23.492-34.045,46.042c2.833,15.901,12.691,29.716,24.26,40.953 l61.246,61.246C318.007,238.709,355.927,196.76,355.927,145.951z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.3062,
    y1: 397.7906,
    x2: 331.8062,
    y2: 299.2806,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2EDF2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_18_)"
    },
    d: "M294.537,96.808c-20.831-1.015-38.086,15.347-38.527,35.849 c-0.001,0.045-0.016,0.045-0.017,0c-0.442-20.502-17.697-36.864-38.527-35.849c-22.878,1.114-38.063,23.492-34.045,46.042 c6.756,37.926,53.434,64.039,68.149,71.404c2.793,1.397,6.073,1.397,8.866,0c14.715-7.364,61.392-33.477,68.149-71.404 C332.599,120.299,317.415,97.923,294.537,96.808z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHouse);
export default __webpack_public_path__ + "static/media/icon-house.e86e8153d5076e3e479430d2d692ac1f.svg";
export { ForwardRef as ReactComponent };